import React from 'react';
import { bool, func } from 'prop-types';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const ImageNav = React.memo(({
  disabled,
  onClick,
  iconName,
  direction,
}) => {
    
    return (
        <button
            type="button"
            className={`image-gallery-icon image-gallery-${direction}-nav`}
            disabled={disabled}
            onClick={onClick}
            aria-label="Previous Slide"
        >
            <FontAwesomeIcon
                icon={iconName}
                size="2x"
            />
        </button>
    );
});

ImageNav.displayName = 'ImageNav';

ImageNav.propTypes = {
  disabled: bool.isRequired,
  onClick: func.isRequired,
};


export default ImageNav;